import type { ApiSessionUser } from "@src/api/users";

/**
 * Проверяет, что пользователь загружен с подразделениями (после bootstrap).
 *
 * @param user кандидат на session user
 */
export function isApiSessionUser(user: ApiSessionUser | null | undefined): user is ApiSessionUser {
    return user != null && Array.isArray(user.DivisionCodes) && Array.isArray(user.Divisions);
}
